/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:31 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";
    var MainContainerLayout = require("connection-views/layouts/MainContainerLayout"),
        ProfileView = require("connection-views/KPsTab/ProfileView"),
        ProfileModel = require("connection-models/ProfileModel"),
        TicketTabController = require("connection-controllers/ticketTab/TicketTabController"),
        NotificationTabController = require("connection-controllers/notificationTab/NotificationTabController"),
        KPsTabController = require("connection-controllers/KPsTab/KPsTabController"),
        ChatTabController = require("connection-controllers/chatTab/ChatTabController"),
        TabsController = require("connection-controllers/TabsController"),
        CP_CONST = require("connection-const"),

        MainContainerController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        var logger = LEConnection.logger;
        MainContainerController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize: entered", "MainContainerController");
                this.model = options.model;
                this.visibility = options.visibility || {};
                this._initViews();
                this._renderMainContainerLayout();
                this._setEventListeners();
                this.tabsController = new TabsController({
                    connectionPanelContextModel: this.model,
                    visibility: this.visibility
                });
                this.kpsTabController = new KPsTabController({
                    connectionPanelContextModel: this.model
                });
                if (this.visibility[CP_CONST.VISIBILITY.CASES]) {
                    this.TicketTabController = new TicketTabController({
                        connectionPanelContextModel: this.model,
                        isCreateCaseVisible: this.visibility[CP_CONST.VISIBILITY.CREATE_CASE]
                    });
                }
                if (this.visibility[CP_CONST.VISIBILITY.CHAT] /*!== CP_CONST.VISIBILITY.CHAT_NOT_AGENTS*/) {
                    this._chatTabController = new ChatTabController({connectionPanelContextModel: this.model});
                }
                this.model.setNotificationCenterEnabled(this.visibility[CP_CONST.VISIBILITY.NOTIFICATION_CENTER]);
                this.notificationTabController = new NotificationTabController({
                    connectionPanelContextModel: this.model
                });

                this._renderViews();
            },

            _initViews: function () {
                this.mainContainerLayout = new MainContainerLayout({model: this.model});
                this.profileView = new ProfileView({
                    model: new ProfileModel()
                });
            },
            _renderMainContainerLayout: function () {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:showRegion:mainContainer", {
                    view: this.mainContainerLayout
                });
            },
            _setEventListeners: function () {
                LEConnection.vent.on("MainContainerController::showRegion:notificationRegion", this._showNotificationRegion, this);
                LEConnection.vent.on("MainContainerController::showRegion:tabsRegion", this._showTabsRegion, this);
                LEConnection.vent.on("MainContainerController::showRegion:chatRegion", this._showChatRegion, this);
                LEConnection.vent.on("MainContainerController::showRegion:KPsRegion", this._showKPsRegion, this);
                LEConnection.vent.on("MainContainerController::showRegion:ticketRegion", this._showTicketRegion, this);
            },

            _showTabsRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.mainContainerLayout.tabsRegion, options.view);
                }
            },
            _showNotificationRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.mainContainerLayout.notificationRegion, options.view);
                }
            },
            _showChatRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.mainContainerLayout.chatRegion, options.view);
                }
            },
            _showKPsRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.mainContainerLayout.KPsRegion, options.view);
                }
            },

            _showTicketRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.mainContainerLayout.ticketRegion, options.view);
                }
            },

            _showRegion: function (region, view) {
                if (this.mainContainerLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.mainContainerLayout, "render", function () {
                        region.show(view);
                    });
                }
            },

            _renderViews: function () {
                this._showRegion(this.mainContainerLayout.profileRegion, this.profileView);
                //this._showRegion(this.mainContainerLayout.tabsRegion, this.tabsView);
                //this._showRegion(this.mainContainerLayout.KPsRegion, this.kpsTabLayout);
                //this._showRegion(this.mainContainerLayout.chatRegion, this.charTabLayout );
            },

            //-------------------------------------------------------------
            // loader functions
            //-------------------------------------------------------------

            _showLoader: function () {
//                this._showRegion(this.kpsTabLayout.areaRegion, this.kPsSnippetsCompositeView);
//                this.kpsTabLayout.showLoader();

            },

            _closeLoader: function () {
//                this.kpsTabLayout.closeLoader();
//                this.kpsTabLayout.areaRegion.$el.removeClass("loader-min-height");
            }
        });
    });
    return MainContainerController;
});
